import { Button, Select } from 'antd';
import styled from 'styled-components';

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100dvw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Container = styled.div`
  position: absolute;
  border-radius: 2rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Header = styled.div`
  padding: 1rem 2rem;
  font-size: 1.8rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray400};
`;

export const CloseButton = styled.button`
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.6rem;
  border-radius: 100%;
  padding: 0.4rem;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray600};
    color: white;
  }
`;

export const Main = styled.div`
  transition: 0.4s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  padding: 2rem;

  .ant-select-selection-item {
    font-family: 'SUIT', 'Noto Sans KR', Roboto, 'Nanum Gothic', 'Open Sans', sans-serif !important;
    font-size: 1.8rem !important;
    font-weight: 700 !important;
  }
`;

export const Contents = styled.div`
  font-size: 2rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: ${(props) => props.theme.colors.txt300};
`;

export const length = styled.div`
  font-size: 3rem;
  font-weight: 800;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const bottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
`;

export const CancelButton = styled(Button)`
  background-color: #ff4d4f; /* 빨강 */
  color: white;
  font-size: 18px;
  height: 48px;
  width: 100px;
  border: none;

  &:hover {
    border: 1px solid #d9363e !important;
    color: #d9363e !important;
  }
`;

export const ConfirmButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.main};
  color: white;
  font-size: 18px;
  height: 48px;
  width: 100px;
  border: none;

  &:hover {
    color: ${(props) => props.theme.colors.main} !important;
    border: 1px solid ${(props) => props.theme.colors.main} !important;
  }
`;
